<template>
  <Headers :type="prop.type" :countDown="prop.countDown"> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep :cardName="prop.cardName" :currentStep="7">
    </PogressBarStep>
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content']">
          <div :class="[deviceType, 'separator']">
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'inputText']">
                <InputText
                  class="inputcomponent"
                  v-model="principalDetails.name"
                  :value="principalDetails.name"
                  field="name"
                  :required="false"
                  :placeholder="t('ccOnBoarding.principalCard.nameOnCard')"
                  :max-length="19"
                  :autocomplete="'new-password'"
                  @keydown="handleNameKeyDown"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div
                v-if="
                  principalDetails.deliveryOption &&
                  principalDetails.deliveryOption == 'B'
                "
                :class="[deviceType, 'flex_half']"
              >
                <DropDown
                  v-model="principalDetails.deliveryOption"
                  :selectedOption="principalDetails.deliveryOption"
                  :options="deliveryList"
                  :value="deliveryList"
                  field="deliveryOption"
                  :placeholder="
                    t('ccOnBoarding.principalCard.cardDeliveryOption')
                  "
                  :disabled="
                    (prop.ekyc == 'FAILED' ||
                      prop.ekyc == 'SKIP' ||
                      prop.ekyc == '') &&
                    prop.verification == 'false'
                  "
                />
              </div>
              <div
                v-else-if="
                  !principalDetails.deliveryOption ||
                  principalDetails.deliveryOption == 'H'
                "
                class="flex"
              >
                <DropDown
                  v-model="principalDetails.deliveryOption"
                  :selectedOption="principalDetails.deliveryOption"
                  :options="deliveryList"
                  :value="deliveryList"
                  field="deliveryOption"
                  :placeholder="
                    t('ccOnBoarding.principalCard.cardDeliveryOption')
                  "
                  :disbaled="true"
                />
              </div>
              <div
                v-if="principalDetails.deliveryOption == 'B'"
                :class="[deviceType, 'flex_half']"
              >
                <DropDown
                  v-if="principalDetails.deliveryOption == 'B'"
                  v-model="principalDetails.branch"
                  :selectedOption="principalDetails.branch"
                  :options="branchList"
                  :value="branchList"
                  field="branch"
                  :placeholder="t('ccOnBoarding.principalCard.branch')"
                />
              </div>
            </div>
            <div v-if="principalDetails.deliveryOption == 'H'">
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    class="inputcomponent"
                    v-model="principalDetails.address1"
                    field="deliveryAddress1"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.principalCard.deliveryAddress1')
                    "
                    :max-length="50"
                    :autocomplete="'new-password'"
                  />
                </div>
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    class="inputcomponent"
                    v-model="principalDetails.address2"
                    field="deliveryAddress2"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.principalCard.deliveryAddress2')
                    "
                    :max-length="50"
                    :autocomplete="'new-password'"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    class="inputcomponent"
                    v-model="principalDetails.address3"
                    field="deliveryAddress3"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.principalCard.deliveryAddress3')
                    "
                    :max-length="50"
                    :autocomplete="'new-password'"
                  />
                </div>
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    v-bind="$attrs"
                    class="inputcomponent"
                    v-model="principalDetails.postCode"
                    field="postCode"
                    :postCode="true"
                    :required="false"
                    :placeholder="t('ccOnBoarding.principalCard.postCode')"
                    :max-length="5"
                    :autocomplete="'new-password'"
                    onkeypress="
                      return event.charCode >= 48 && event.charCode <= 57;
                    "
                    :number="'true'"
                    :type="'text'"
                    :inputmode="'numeric'"
                    :pattern="'[0-9]*'"
                    @keydown.enter.prevent="handleEnterKey"
                  />
                </div>
              </div>

              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    :disabled="true"
                    class="inputcomponent"
                    v-model="principalDetails.city"
                    :value="principalDetails.city"
                    field="city"
                    :required="false"
                    :placeholder="t('ccOnBoarding.principalCard.city')"
                    :autocomplete="'new-password'"
                  />
                </div>

                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    class="inputcomponent"
                    :disabled="true"
                    v-model="principalDetails.state"
                    :value="principalDetails.state"
                    field="state"
                    :required="false"
                    :placeholder="t('ccOnBoarding.principalCard.state')"
                    :max-length="21"
                    :autocomplete="'new-password'"
                  />
                </div>
              </div>
            </div>
            <div v-if="prop.cardId == 'JC'" :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <DropDown
                  v-model="principalDetails.jcklClubBillPeriod"
                  :selectedOption="principalDetails.jcklClubBillPeriod"
                  :options="jcklClubBillPeriodList"
                  :value="jcklClubBillPeriodList"
                  field="jcklClubBillPeriodOption"
                  :placeholder="
                    t('ccOnBoarding.principalCard.jcklClubBillPeriod')
                  "
                />
              </div>
              <div :class="[deviceType, 'flex_half']">
                <DropDown
                  v-model="principalDetails.jcklFeeAmount"
                  :selectedOption="principalDetails.jcklFeeAmount"
                  :options="jcklFeeAmountList"
                  :value="jcklFeeAmountList"
                  field="jcklFeeAmountOption"
                  :placeholder="t('ccOnBoarding.principalCard.jcklFeeAmount')"
                />
              </div>
            </div>
            <div
              class="container"
              :class="{
                hide: prop.type == 'PF_CC',
                agreement: prop.type != 'PF_CC',
              }"
            >
              <p class="description">
                {{ t("ccOnBoarding.principalCard.statement") }}
              </p>
              <div class="agree">
                <section class="radioClass">
                  <RadioButton
                    v-for="option in hrcQuestionnaireEnum"
                    :key="option.value"
                    :label="option.label"
                    :values="option.value"
                    class="radioHorizontal"
                    field="statement"
                    id="q2"
                    :selected-value="prop.principalDetails.eStatement"
                    :label-class="'radioLabel'"
                    @selected="question1Selection"
                    :class="{ 'display-flex': true }"
                  />
                </section>
              </div>
              <pre class="help" v-if="!errorMessage">
                  {{ errorMessage }}</pre
              >
              <pre class="help" v-else-if="error && errorMessage">{{
                errorMessage
              }}</pre>
              <pre class="help" v-else>&nbsp</pre>

              <p
                v-if="
                  principalDetails.eStatement == 'No' &&
                  prop.principalDetails.eStatement == 'No'
                "
                class="remark"
              >
                {{ t("ccOnBoarding.principalCard.statementRemark") }}
              </p>

              <div
                v-if="
                  principalDetails.eStatement == 'No' &&
                  prop.principalDetails.eStatement == 'No'
                "
                :class="[deviceType, 'container']"
              >
                <div class="flex">
                  <DropDown
                    v-model="principalDetails.billingAddress"
                    :selectedOption="principalDetails.billingAddress"
                    :options="billingAddressList"
                    :value="billingAddressList"
                    field="billingAddress"
                    :placeholder="
                      t('ccOnBoarding.principalCard.billingAddress')
                    "
                    :disabled="prop.workplace == 'No'"
                  />
                </div>
              </div>
            </div>
          </div>
          <div :class="[deviceType, 'buttoncontainer']">
            <button
              v-if="prop.summarySetting.principalCardDetailsJump == false"
              :class="[deviceType, 'left-button']"
              type="button"
              @click="handleBack"
            >
              {{ t("ccOnBoarding.back") }}
            </button>
            <div v-else :class="[deviceType, 'left-button:disabled']"></div>
            <button
              v-if="prop.summarySetting.principalCardDetailsJump == false"
              :disabled="isBtnDisabled"
              :class="[deviceType, 'right-button']"
            >
              {{ t("ccOnBoarding.next") }}
            </button>
            <button
              v-else
              :class="[deviceType, 'summary-button']"
              :disabled="isBtnDisabled"
            >
              {{ t("ccOnBoarding.backToSummary") }}
            </button>
          </div>
        </div>
      </div>
    </Form>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  computed,
  onBeforeMount,
  type PropType,
  watch,
  onMounted,
  type Ref,
} from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import DropDown from "./components/NewDropDownComponent.vue";
import InputText from "./components/NewInputTextComponent.vue";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type { PrincipalCardDetails } from "@/interface/FormCC";
import { deviceDetect } from "mobile-device-detect";
import type { PersonalInformation } from "@/interface/FormCC";
import hrcQuestionnaireEnum from "@/enum/HRCQuestionnaireEnum";
import RadioButton from "./components/NewRadioButtonComponent.vue";
import type { SummarySetting } from "@/interface/FormCC";

const deviceType = ref("");

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
  if (prop.idType != "0" && prop.principalDetails.deliveryOption == "") {
    prop.principalDetails.deliveryOption = "B";
  }
});

const prop = defineProps({
  principalDetails: {
    type: Object as PropType<PrincipalCardDetails>,
    required: true,
  },
  ekyc: {
    type: String,
    required: true,
  },
  workplace: {
    type: String,
    required: true,
  },
  address: {
    type: Object as PropType<PersonalInformation>,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  profession: {
    type: String,
    required: true,
  },
  idType: {
    type: String,
    required: true,
  },
  cardId: {
    type: String,
  },
  cardName: {
    type: String,
    required: true,
  },
  summarySetting: {
    type: Object as PropType<SummarySetting>,
    required: true,
  },
  type: {
    type: String,
  },
  countDown: {
    type: String,
  },
  verification: {
    type: String,
  },
});

const { t } = i18n.global;
const isClear = ref("false");
const error = ref(true);
const errorMessage = ref("");
let previousValue: string | null = null;

//List
const deliveryList = ref([]);
const genericList = ref([]);
const billingAddressList = ref([]);
const branchList = ref([]);
const jcklClubBillPeriodList = ref([]);
const jcklFeeAmountList = ref([]);

interface Branch {
  code: string;
  value: string;
}

const branchListValue: Ref<Branch[]> = ref([]);

onBeforeMount(() => {
  MasterService.getMasterData().then((res) => {
    deliveryList.value = res.data.deliveryType;
    genericList.value = res.data.genericOptionType;
    billingAddressList.value = res.data.billingAddressType;
    jcklClubBillPeriodList.value = res.data.jcklClubBillPeriod;
    jcklFeeAmountList.value = res.data.jcklFeeAmount;
  });
  const requestModel = {
    type: "CC",
  };

  MasterService.branchCode(requestModel)
    .then((res) => {
      branchList.value = res.data.responseModel.branchList;
      branchListValue.value = res.data.responseModel.branchList;
    })
    .catch((e) => {});
  if (
    prop.principalDetails.deliveryOption == "H" &&
    prop.principalDetails.address1 == ""
  ) {
    prop.principalDetails.address1 = prop.address.residentialAddress1;
    prop.principalDetails.address2 = prop.address.residentialAddress2;
    prop.principalDetails.address3 = prop.address.residentialAddress3;
    prop.principalDetails.postCode = prop.address.postCode;
    postCodeData();
  }
  // prop.principalDetails.deliveryOption = "B";
});

if (prop.type == "BIO" && prop.verification == "true") {
  prop.principalDetails.deliveryOption = "H";
} else if (
  (prop.ekyc == "FAILED" || prop.ekyc == "SKIP" || prop.ekyc == "") &&
  prop.principalDetails.deliveryOption == ""
) {
  prop.principalDetails.deliveryOption = "B";
} else if (
  prop.ekyc == "COMPLETE" &&
  prop.principalDetails.deliveryOption == ""
) {
  prop.principalDetails.deliveryOption = "H";
}

if (prop.principalDetails.eStatement == "") {
  prop.principalDetails.eStatement = "Yes";
}

const question1Selection = (option: string) => {
  prop.principalDetails.eStatement = option;
  error.value = false;
};

const schema = computed(() => {
  const billingAddress = prop.principalDetails.eStatement == "No";
  const branch = prop.principalDetails.deliveryOption == "B";
  const jcklCard = prop.cardId == "JC";
  return {
    name: "required|alphabetAndSpaceFormat",
    deliveryOption: "required",
    branch: branch ? "required" : "",
    deliveryAddress1: branch ? "" : "required",
    // deliveryAddress2: branch ? "" : "required",
    postCode: branch
      ? ""
      : "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat",
    statement: "required",
    billingAddress: billingAddress ? "required" : "",
    jcklClubBillPeriodOption: jcklCard ? "required" : "",
    jcklFeeAmountOption: jcklCard ? "required" : "",
  };
});

async function postCodeData() {
  if (prop.principalDetails.postCode.length >= 5) {
    try {
      const res = await MasterService.checkPostCode(
        prop.principalDetails.postCode,
      );
      prop.principalDetails.city = res.data.responseModel.city;
      prop.principalDetails.state = res.data.responseModel.state;
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat";
    } catch (e) {
      prop.principalDetails.city = "";
      prop.principalDetails.state = "";
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:5|requiredNumber|invalidPostCode|numberFormat";
    }
  }
}

const getValue = computed(async () => {
  if (prop.principalDetails.postCode.length < 5) {
    prop.principalDetails.city = "";
    prop.principalDetails.state = "";
  } else if (prop.principalDetails.postCode.length >= 5) {
    await postCodeData();
  }

  return {
    city: prop.principalDetails.city,
    state: prop.principalDetails.state,
  };
});

const cityValue = ref("");
const stateValue = ref("");

async function updateValues() {
  const newValues = await getValue.value;
  cityValue.value = newValues.city;
  stateValue.value = newValues.state;
}

watch(getValue, updateValues, { immediate: true });

const onInvalidSubmit = () => {
  if (prop.principalDetails.eStatement == "") {
    errorMessage.value = t("ccOnBoarding.principalCard.error");
  }
};

const emit = defineEmits(["nextStep", "previousStep", "submit", "jumpStep"]);

const onSubmit = () => {
  emit("submit");
};

const handleBack = () => {
  if (prop.type == "PF_CC") {
    emit("jumpStep", 4, "", 7);
  } else if (prop.idType != "1" && prop.profession == "20") {
    emit("jumpStep", 5, "", 7);
  } else {
    emit("jumpStep", 6, "", 7);
  }
};

const handleNameKeyDown = (event: KeyboardEvent) => {
  const isSymbol = /[^\sa-zA-Z_]/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const isBtnDisabled = computed(() => {
  return (
    prop.principalDetails.name.length == 0 ||
    prop.principalDetails.deliveryOption.length == 0 ||
    (prop.principalDetails.deliveryOption == "B" &&
      prop.principalDetails.branch.length == 0) ||
    (prop.principalDetails.deliveryOption != "B" &&
      prop.principalDetails.address1.length == 0) ||
    // (prop.principalDetails.deliveryOption != "B" &&
    //   prop.principalDetails.address2.length == 0) ||
    (prop.principalDetails.deliveryOption != "B" &&
      prop.principalDetails.postCode.length == 0) ||
    prop.principalDetails.eStatement.length == 0 ||
    (prop.principalDetails.billingAddress == "No" &&
      prop.principalDetails.billingAddress.length == 0) ||
    (prop.cardId == "JC" &&
      (prop.principalDetails.jcklClubBillPeriod.length == 0 ||
        prop.principalDetails.jcklFeeAmount.length == 0))
  );
});

watch(
  () => prop.principalDetails.deliveryOption,
  (newValue, oldValue) => {
    if (newValue) {
      isClear.value = oldValue === "0" ? "1" : "0";
    }
  },
);

watch(
  () => prop.principalDetails.deliveryOption,
  (newValue) => {
    if (newValue == "H") {
      prop.principalDetails.address1 = prop.address.residentialAddress1;
      prop.principalDetails.address2 = prop.address.residentialAddress2;
      prop.principalDetails.address3 = prop.address.residentialAddress3;
      prop.principalDetails.postCode = prop.address.postCode;
      postCodeData();
    }
  },
);

watch(
  () => prop.principalDetails.deliveryOption,
  (newValue) => {
    if (newValue) {
      prop.principalDetails.branch = "";
      prop.principalDetails.branchValue = "";
    }
  },
);

watch(
  () => prop.principalDetails.eStatement,
  (newValue) => {
    if (newValue == "Yes") {
      prop.principalDetails.billingAddress = "";
    }
  },
);

watch(
  () => prop.principalDetails.eStatement,
  (newValue) => {
    if (newValue == "No" && prop.workplace == "No") {
      prop.principalDetails.billingAddress = "H";
    }
  },
);

if (prop.principalDetails.eStatement == "No" && prop.workplace == "No") {
  prop.principalDetails.billingAddress = "H";
}

watch(
  () => prop.principalDetails.branch,
  (newValue) => {
    if (newValue) {
      const branchObject = branchListValue.value.find(
        (branch) => branch.code === newValue,
      );
      if (branchObject) {
        prop.principalDetails.branchValue = branchObject.value;
      } else {
        prop.principalDetails.branchValue = "";
      }
    }
  },
);

const handleEnterKey = () => {};
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.radioClass {
  display: flex;
  align-items: flex-end;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.agreement {
  display: block !important;
}

.container2 {
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 10px;
}

.help {
  color: red;
  margin-bottom: 0px;
  font:
    400 16px/130% "Outfit",
    sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.flex_half {
  width: 50%;
}
.flex {
  width: 100%;
}

.separator {
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 37px;
}

.flex_dropdown {
  display: flex;
  width: 30%;
}

.flex_inputText {
  width: 70%;
}

.summary-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
  transition: background-color 0.3s ease;
}

.summary-button:hover {
  background-image:
    linear-gradient(120deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:active {
  background-image:
    linear-gradient(120deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;

  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.inputText {
  width: 100%;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.agree {
  display: flex;
  align-items: flex-start;
}

/* .radioClass {
  display: flex;
} */

.radioHorizontal {
  margin-right: 24px !important;
  color: rgba(0, 0, 0, 0.38);
  margin-bottom: 5px;
}

.description {
  color: #212121;
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  text-align: left;

  position: relative;
  align-self: stretch;
}

.remark {
  font: 500 14px/130% "Outfit";
  color: #757575;
}

.brLine {
  margin-bottom: 18px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}
.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}
.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}
.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .summary-button:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .summary-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }
}

.separator .container {
  max-width: none;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.inner-last:is(.Mobile) {
  border-top: 1px solid #e4e4e4;
  padding: 0px 20px;
  border-bottom: 1px solid #e4e4e4;
}

.container:is(.Mobile),
.container2:is(.Mobile) {
  flex-direction: column;
  gap: 14px;
}

.container3:is(.Mobile) {
  max-width: none !important;
}

.container4:is(.Mobile) {
  flex-direction: column;
  gap: 0;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}

.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.flex_third:is(.Mobile) {
  width: 30%;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.summary-button:is(.Mobile) {
  flex: 0 0 100%;
}

.summary-button:disabled:is(.Mobile) {
  flex: 0 0 100%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

.content:is(.Mobile) {
  padding: 0;
}
</style>
